import { render, staticRenderFns } from "./SpesifikasiNonAktifEmas.vue?vue&type=template&id=4a62b204&"
import script from "./SpesifikasiNonAktifEmas.vue?vue&type=script&lang=js&"
export * from "./SpesifikasiNonAktifEmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports